import request from '../utils/request'

export function customerAllotListPageApi (data) {
  return request({
    url: 'api/customerAllot/allotListPage',
    method: 'post',
    data
  })
}

export function customerAllotLogListPageApi (data) {
  return request({
    url: 'api/customerAllot/allotLogListPage',
    method: 'post',
    data
  })
}

export function customerAllotIgnoreAllotApi (data) {
  return request({
    url: 'api/customerAllot/ignoreAllot',
    method: 'post',
    data
  })
}

export function customerAllotDutyApi (data) {
  return request({
    url: 'api/customerAllot/allotDuty',
    method: 'post',
    data
  })
}
